$( document ).ready(function() {
  $('.related-blogs .blogs-wrapper').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:"<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0750/9475/3571/files/left-arrow.png?v=1738258967' /></button>",
    nextArrow:"<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0750/9475/3571/files/right-arrow.png?v=1738258874' /></button>",
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
  });
});